import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { shouldIgnoreSentryError } from './app/utils/helpers';
import * as Sentry from '@sentry/angular';
import { environment } from './environments/environment';

Sentry.init({
  dsn: environment.sentryDsn,
  // Setting this option to true will send default PII data to Sentry.
  sendDefaultPii: true,
  release: 'defectwise-owners-portal@' + environment.version,
  dist: '1',
  environment: environment.production ? 'production' : 'development',
  // debug: !environment.production,
  enabled: environment.production,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],
  beforeSend(event) {
    if (shouldIgnoreSentryError(event)) {
      return null;
    }
    return event;
  },
  tracesSampleRate: environment.production ? 0.5 : 0,
  replaysOnErrorSampleRate: environment.production ? 1.0 : 0,
  // replaysSessionSampleRate: environment.production ? 0.1 : 0,
  // reducing to only capture errors as keep going over limit
  replaysSessionSampleRate: 0,
});

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err)
);
